// Copyright (c) 2017 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../actions-list';
import {getDebitTypes} from '../../shared/repositories';

export const readDebitTypes = () =>
    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const data = await getDebitTypes();

            dispatch({
                data: data.filter(item => item.key !== 'N'),
                type: actions.UPDATE_TCSM_CLAIM_DEBIT_TYPES
            });

        } catch (error) {

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/tcsm/claim-debit/action-creators/debit-types.js